import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/Button'
import Checkbox from 'components/Form/Checkbox'
import Input from 'components/Form/Input'
import Textarea from 'components/Form/Textarea'
import classes from './EditCategory.scss'

import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const EditCategory = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Editing Category
        <span className={classes['header-title--unimportant']}> – {props.category.id}</span>
      </div>

      <div className={classes['header-buttons']}>
        <Button submit options={['green', 'small', 'desktop']}>
          Update
        </Button>

        <Button confirm options={['red', 'small']} callback={() => props.handleDelete(props.category.id)}>
          Delete
        </Button>
      </div>
    </header>

    <fieldset>
      <Input label='Name' placeholder='name' {...props.fields.name} />
      <Textarea label='Description' placeholder='A quick description for the category.' {...props.fields.desc} />
      <Input label='Priority'
        subLabel='Lower numbers are shown first on the Pricelist.'
        placeholder='Priority'
        pattern='[0-9]+'
        type='tel'
        {...props.fields.priority}
      />

      <Checkbox label='Hidden?' {...props.fields.hidden} />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Update Category
      </Button>
    </footer>
  </form>
)

EditCategory.propTypes = {
  category: PropTypes.object.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  handleDelete: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default EditCategory



// WEBPACK FOOTER //
// ./src/components/Categories/Edit/EditCategory.js